import { useQuery } from "@tanstack/react-query";
import { getExtractionConfigurations } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const getExtractionConfigurationsQueryKey = (
	offset: number,
	limit: number,
	searchQuery?: string,
) => ["EXTRACTION_CONFIGURATIONS_QUERY", offset, limit, searchQuery];

export function useExtractionConfigurationsQuery(searchQuery?: string) {
	return useQuery({
		queryKey: getExtractionConfigurationsQueryKey(0, 100, searchQuery),
		queryFn: processResponse(() => getExtractionConfigurations(0, 100, searchQuery || null)),
	});
}
